import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './meeting-info.types';

export const meetingInfoSelectors = {
  ...generateResourceSelectors<types.IMeetingInfo>((state) => state.resource.meetingInfo),
};
